function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import axios from 'axios';
import { buildDatasetQuery } from './datasetUtils';
import mapboxgl from '!mapbox-gl';
import ReactDOM from 'react-dom';
import { findVisitPoi } from './modelUtils';
var extrudedBuildingsLayerID = '3d-buildings';
export var addJourneysLayer = function addJourneysLayer(map, journeys) {
  !!map.getLayer('journeysLinesLayer') && map.removeLayer('journeysLinesLayer');
  !!map.getLayer('journeysPointsLayer') && map.removeLayer('journeysPointsLayer');
  !!map.getSource('journeysDataLines') && map.removeSource('journeysDataLines');
  !!map.getSource('journeysDataPoints') && map.removeSource('journeysDataPoints');
  var wg = [].concat(journeys.withGrandPariGeojsonCoordinates);
  var wog = [].concat(journeys.withoutGrandPariGeojsonCoordinates);
  var featuresForLines = [{
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [].concat(wog)
    },
    properties: {
      name: 'withoutGrandPariGeojsonCoordinates',
      width: 9,
      color: '#E84261'
    }
  }];
  if ((journeys === null || journeys === void 0 ? void 0 : journeys.duration) < (journeys === null || journeys === void 0 ? void 0 : journeys.sansDuration)) {
    featuresForLines.push({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [].concat(wg)
      },
      properties: {
        name: 'withGrandPariGeojsonCoordinates',
        width: 6,
        color: '#039DD1'
      }
    });
  }
  var geojsonLines = {
    type: 'FeatureCollection',
    features: featuresForLines
  };
  var geojsonPoints = {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [].concat(wg.shift())
      },
      properties: {
        name: 'start'
      }
    }, {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [].concat(wg.pop())
      },
      properties: {
        name: 'finish'
      }
    }]
  };

  // const wg = journeys.withGrandPariGeojsonCoordinates.filter(function(item, pos) {
  //   return journeys.withGrandPariGeojsonCoordinates.indexOf(item) == pos;
  // })
  // const wog = journeys.withoutGrandPariGeojsonCoordinates.filter(function(item, pos) {
  //   return journeys.withoutGrandPariGeojsonCoordinates.indexOf(item) == pos;
  // })

  // for (
  //   let i = 0;
  //   i + 2 < wog.length;
  //   i += 2
  // ) {
  // let bold = false
  // if (wg.includes(wog[i]) && wg.includes(wog[i+1])){
  //   bold =
  //     (
  //       wog[i] === wg[wg.indexOf(wog[i])] &&
  //       wog[i + 1] === wg[wg.indexOf(wog[i]) + 1] &&
  //       wog[i + 2] === wg[wg.indexOf(wog[i]) + 2] &&
  //       wog[i + 3] === wg[wg.indexOf(wog[i]) + 3]
  //     ) ||
  //     (
  //       wog[i] === wg[wg.indexOf(wog[i])] &&
  //       wog[i + 1] === wg[wg.indexOf(wog[i]) - 1] &&
  //       wog[i + 2] === wg[wg.indexOf(wog[i]) - 2] &&
  //       wog[i + 3] === wg[wg.indexOf(wog[i]) - 3]
  //     )
  // }

  // geojsonLines.features.push({
  //   type: 'Feature',
  //   geometry: {
  //     type: 'LineString',
  //     coordinates: [
  //       [wog[i], wog[i + 1]],
  //       [wog[i + 2], wog[i + 3]],
  //     ],
  //   },
  //   properties: {
  //     name: 'withoutGrandPariGeojsonCoordinates',
  //     width: bold ? 9 : 6,
  //     color: '#E84261',
  //   },
  // });

  //   geojsonLines.features[0].geometry.coordinates.push([wog[i], wog[i + 1]])
  // }

  // let wgFeature = {
  //   type: 'Feature',
  //   geometry: {
  //     type: 'LineString',
  //     coordinates: []
  //   },
  //   properties: {
  //     name: 'withGrandPariGeojsonCoordinates',
  //     width: 6,
  //     color: '#039DD1'
  //   }
  // }

  // for (let i = 0; i < wg.length; i += 2) {
  //   if (i === 0)
  //     geojsonPoints.features[0].geometry.coordinates = [
  //       wg[i],
  //       wg[i + 1],
  //     ];
  //   if (i === wg.length - 2)
  //     geojsonPoints.features[1].geometry.coordinates = [
  //       wg[i],
  //       wg[i + 1],
  //     ];

  //   geojsonLines.features[1].geometry.coordinates.push([
  //     wg[i],
  //     wg[i + 1],
  //   ]);

  // wgFeature.geometry.coordinates.push([
  //   wg[i],
  //   wg[i + 1],
  // ]);
  // }

  // geojsonLines.features.push(wgFeature)

  map.addSource('journeysDataLines', {
    type: 'geojson',
    data: geojsonLines
  });
  map.addSource('journeysDataPoints', {
    type: 'geojson',
    data: geojsonPoints
  });
  map.addLayer({
    id: 'journeysLinesLayer',
    type: 'line',
    source: 'journeysDataLines',
    paint: {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width']
    },
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    }
  });
  map.addLayer({
    id: 'journeysPointsLayer',
    type: 'circle',
    source: 'journeysDataPoints',
    paint: {
      'circle-color': '#039DD1',
      'circle-radius': 10,
      'circle-stroke-color': '#0C208F',
      'circle-stroke-width': 4
    }
  });
};
export var removeJourneysLayer = function removeJourneysLayer(map) {
  map.getLayer('journeysLinesLayer') && map.removeLayer('journeysLinesLayer');
  map.getLayer('journeysPointsLayer') && map.removeLayer('journeysPointsLayer');
  map.getSource('journeysDataLines') && map.removeSource('journeysDataLines');
  map.getSource('journeysDataPoints') && map.removeSource('journeysDataPoints');
};
export var setDataSetSource = function setDataSetSource(props) {
  var _fields;
  var map = props.map,
    datasetId = props.datasetId,
    projectId = props.projectId,
    datasetFields = props.datasetFields,
    datasetRequiredFields = props.datasetRequiredFields,
    selectedValues = props.selectedValues,
    searchMasks = props.searchMasks,
    lang = props.lang,
    isCluster = props.isCluster,
    iconFieldName = props.iconFieldName,
    filterLogic = props.filterLogic,
    filtersMap = props.filtersMap,
    tileUrl = props.tileUrl;
  var baseurl = tileUrl + "/datasets/" + projectId + "/" + datasetId + "/tile?request=";
  var request = {
    cluster: isCluster,
    iconField: iconFieldName,
    fields: (_fields = {
      guid: 'guid',
      'properties.mediasets': 'mediasets'
    }, _fields["properties." + iconFieldName] = iconFieldName, _fields),
    requiredFields: datasetRequiredFields || [],
    query: buildDatasetQuery(selectedValues, searchMasks, lang, filterLogic, undefined, filtersMap),
    lang: lang,
    x: '{x}',
    y: '{y}',
    z: '{z}'
  };
  datasetFields.map(function (field) {
    return request['fields']["properties." + field] = field;
  });
  var sourceData = {
    type: 'vector',
    tiles: [baseurl + JSON.stringify(request)],
    promoteId: 'guid'
  };
  map.addSource(datasetId, sourceData);
};
export var updateDatasetSource = function updateDatasetSource(props) {
  var map = props.map,
    datasetId = props.datasetId,
    selectedValues = props.selectedValues,
    searchMasks = props.searchMasks,
    lang = props.lang,
    filterLogic = props.filterLogic,
    filtersMap = props.filtersMap;
  var source = map.getSource(datasetId);
  if (source && source.tiles) {
    var newRequest;
    var url = new URL(source.tiles);
    newRequest = JSON.parse(url.searchParams.get('request'));
    newRequest['query'] = buildDatasetQuery(selectedValues, searchMasks, lang, filterLogic, undefined, filtersMap), newRequest['lang'] = lang;
    source.setTiles(["" + url.origin + url.pathname + "?request=" + JSON.stringify(newRequest)]);
    source.reload();
  }
};
export var addDataSetLayer = function addDataSetLayer(props) {
  var map = props.map,
    datasetId = props.datasetId,
    selectItem = props.selectItem,
    deselectItem = props.deselectItem,
    hoverItem = props.hoverItem,
    hoverOffItem = props.hoverOffItem,
    PopUpComponent = props.PopUpComponent,
    showPopup = props.showPopup,
    urlChangeEvent = props.urlChangeEvent,
    itemChangeEvent = props.itemChangeEvent,
    itemHoverEvent = props.itemHoverEvent,
    generateShortUrl = props.generateShortUrl,
    layers = props.layers,
    isMobile = props.isMobile,
    history = props.history,
    lang = props.lang,
    projectConfigs = props.projectConfigs,
    displayDatasetLayerIcons = props.displayDatasetLayerIcons,
    iconMapping = props.iconMapping,
    iconFieldName = props.iconFieldName,
    mprApiUrl = props.mprApiUrl;
  var hoveredFeatureId = null;
  var selectedFeatureId = null;
  var hoverPopup = null;
  var selectedPopup = null;
  var filteredLayers = {
    selectedFeature: 'selectedFeature',
    feature_icon: 'feature_icon',
    feature_icon_hover: 'feature_icon_hover',
    feature_icon_active: 'feature_icon_active'
  };
  var activeFeatureStyles = {};
  layers.map(function (layer) {
    var filteredLayer = filterLayer(layer, datasetId);
    if (layer.id !== 'feature_circle_active') {
      map.addLayer(filteredLayer);
    } else {
      activeFeatureStyles = filteredLayer;
    }
    filteredLayers[filteredLayer.id] = filteredLayer;
  });
  var featureIconLayer, featureIconLayerHover, featureIconLayerActive;
  if (displayDatasetLayerIcons) {
    featureIconLayer = {
      id: 'feature_icon',
      type: 'symbol',
      filter: ['!has', 'cluster'],
      source: datasetId,
      'source-layer': 'default',
      layout: {
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-size': ['interpolate', ['exponential', 2], ['zoom'], 0, 1, 19, 0.8]
      }
    };
    featureIconLayerHover = {
      id: 'feature_icon_hover',
      type: 'symbol',
      filter: ['!has', 'cluster'],
      source: datasetId,
      'source-layer': 'default',
      layout: {
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        visibility: 'none'
      }
    };
    featureIconLayerActive = {
      id: 'feature_icon_active',
      type: 'symbol',
      filter: ['!has', 'cluster'],
      source: datasetId,
      'source-layer': 'default',
      layout: {
        'icon-allow-overlap': true,
        'icon-ignore-placement': true
      }
    };
    if (iconMapping && iconMapping.length) {
      featureIconLayer.layout['icon-image'] = ['case'];
      featureIconLayerHover.layout['icon-image'] = ['case'];
      featureIconLayerActive.layout['icon-image'] = ['case'];
    }
    if (iconMapping) {
      iconMapping.forEach(function (icon) {
        featureIconLayer.layout['icon-image'].push(['==', ['get', iconFieldName], icon === null || icon === void 0 ? void 0 : icon.value]);
        featureIconLayer.layout['icon-image'].push((icon === null || icon === void 0 ? void 0 : icon.iconName) || '');
        featureIconLayerHover.layout['icon-image'].push(['==', ['get', iconFieldName], icon === null || icon === void 0 ? void 0 : icon.value]);
        featureIconLayerHover.layout['icon-image'].push((icon === null || icon === void 0 ? void 0 : icon.iconNameHover) || '');
        featureIconLayerActive.layout['icon-image'].push(['==', ['get', iconFieldName], icon === null || icon === void 0 ? void 0 : icon.value]);
        featureIconLayerActive.layout['icon-image'].push((icon === null || icon === void 0 ? void 0 : icon.iconNameActive) || '');
      });
    }
    featureIconLayer.layout['icon-image'].push('');
    featureIconLayerHover.layout['icon-image'].push('');
    featureIconLayerActive.layout['icon-image'].push('');
    map.addLayer(featureIconLayer);
    map.addLayer(featureIconLayerHover);
  }
  if (!document.body.hasAttribute('data-mpr-event-' + itemChangeEvent)) {
    document.addEventListener(itemChangeEvent, function (_ref) {
      var detail = _ref.detail;
      document.body.setAttribute('data-mpr-event-' + itemChangeEvent, 'true');
      if (detail.selectedItem) {
        var feature = JSON.parse(JSON.stringify(detail.selectedItem));
        feature.properties.guid = detail.selectedItem.guid;
        feature.id = detail.selectedItem.guid;
        selectFeature(feature, projectConfigs.isPOIPageEnabled);
      } else {
        deselectFeature(null, map);
      }
    });
  }
  if (!document.body.hasAttribute('data-mpr-event-' + itemHoverEvent)) {
    var hoverFeature = function hoverFeature(feature) {
      if (selectedFeatureId !== feature.guid && hoveredFeatureId !== feature.guid) {
        if (!map) {
          return;
        }
        hoverPopup && hoverPopup.isOpen && hoverPopup.remove();
        var existDefaultFilter = map.getFilter(datasetId + "_feature_circle_default");
        var existHoverFilter = map.getFilter(datasetId + "_feature_circle_hover");
        var existIconsLayerFilter = displayDatasetLayerIcons && map.getFilter('feature_icon');
        var existIconsLayerHoverFilter = displayDatasetLayerIcons && map.getFilter('feature_icon_hover');
        hoveredFeatureId = feature.guid;
        if (PopUpComponent && !isMobile && showPopup && showPopup(feature.properties, 'hover') || !showPopup) {
          var popUpNode = document.createElement('div');
          ReactDOM.render( /*#__PURE__*/React.createElement(PopUpComponent, {
            items: [feature.properties],
            hasSeeMore: true,
            onSeeMore: function onSeeMore() {
              selectItem(feature.guid);
            },
            generateShortUrl: generateShortUrl,
            urlChangeEvent: urlChangeEvent,
            locale: lang,
            domain: projectConfigs.domain,
            projectConfigs: projectConfigs,
            mprApiUrl: mprApiUrl
          }), popUpNode);
          popUpNode.addEventListener('wheel', function (event) {
            map.scrollZoom.wheel(event);
          });
          if (!hoverPopup || hoverPopup && !hoverPopup.isOpen()) {
            hoverPopup = new mapboxgl.Popup({
              closeButton: false,
              offset: 25
            }).setLngLat(feature.geometry.coordinates).setDOMContent(popUpNode).addTo(map);
          }
        }
        map.setFilter(datasetId + "_feature_circle_hover", ['all', existHoverFilter, ['==', 'guid', feature.guid]]);
        map.setLayoutProperty(datasetId + "_feature_circle_hover", 'visibility', 'visible');
        map.setFilter(datasetId + "_feature_circle_default", ['all', existDefaultFilter, ['!=', 'guid', feature.guid]]);
        displayDatasetLayerIcons && map.setFilter('feature_icon_hover', ['all', existIconsLayerHoverFilter, ['==', 'guid', feature.guid]]);
        displayDatasetLayerIcons && map.setLayoutProperty("feature_icon_hover", 'visibility', 'visible');
        displayDatasetLayerIcons && map.setFilter('feature_icon', ['all', existIconsLayerFilter, ['!=', 'guid', feature.guid]]);
      }
    };
    document.addEventListener(itemHoverEvent, function (_ref2) {
      var detail = _ref2.detail;
      document.body.setAttribute('data-mpr-event-' + itemHoverEvent, 'true');
      if (detail.hoveredItem) {
        var feature = JSON.parse(JSON.stringify(detail.hoveredItem));
        feature.properties.guid = detail.hoveredItem.guid;
        feature.id = detail.hoveredItem.guid;
        if (hoveredFeatureId) {
          hoverOffFeature();
        }
        hoverFeature(feature);
      } else {
        hoverOffFeature();
      }
    });
  }
  var selectFeature = function selectFeature(feature, isPOIPageEnabled) {
    if (isPOIPageEnabled === void 0) {
      isPOIPageEnabled = true;
    }
    if (selectedFeatureId !== feature.id && selectedFeatureId !== null) {
      deselectFeature(feature.id, map);
    }
    if (selectedFeatureId === null || selectedFeatureId !== feature.id) {
      var _properties;
      selectedFeatureId = feature.id;
      var existFilter = map.getFilter(datasetId + "_feature_circle_default");
      map.setFilter(datasetId + "_feature_circle_default", ['all', existFilter, ['!=', 'guid', selectedFeatureId]]);
      var existIconsLayerFilter = displayDatasetLayerIcons && map.getFilter('feature_icon');
      displayDatasetLayerIcons && map.setFilter('feature_icon', ['all', existIconsLayerFilter, ['!=', 'guid', selectedFeatureId]]);
      if (PopUpComponent && showPopup && showPopup(feature.properties, 'select') || !showPopup) {
        var popUpNode;
        if (isMobile) {
          popUpNode = document.getElementById('mobilePopupContainer');
        } else {
          popUpNode = document.createElement('div');
        }
        popUpNode.classList.add('selected-popup');
        ReactDOM.render( /*#__PURE__*/React.createElement(PopUpComponent, {
          items: [feature.properties],
          hasSeeMore: !!isMobile && isPOIPageEnabled,
          generateShortUrl: generateShortUrl,
          urlChangeEvent: urlChangeEvent,
          onSeeMore: function onSeeMore() {},
          history: history,
          locale: lang,
          projectConfigs: projectConfigs,
          domain: projectConfigs.domain,
          mprApiUrl: mprApiUrl,
          onClose: deselectItem
        }), popUpNode);
        popUpNode.addEventListener('wheel', function (event) {
          map.scrollZoom.wheel(event);
        });
        if (!isMobile) {
          selectedPopup = new mapboxgl.Popup({
            closeButton: true,
            offset: 25
          }).setLngLat(feature.geometry.coordinates).setDOMContent(popUpNode).addTo(map);
        }
      }
      map.addSource('selectedFeature', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: feature.geometry.coordinates
          },
          properties: (_properties = {}, _properties[iconFieldName] = feature.properties[iconFieldName], _properties)
        }
      });
      map.addLayer(_extends({}, activeFeatureStyles, {
        source: 'selectedFeature',
        'source-layer': ''
      }));
      displayDatasetLayerIcons && map.addLayer(_extends({}, featureIconLayerActive, {
        source: 'selectedFeature',
        'source-layer': ''
      }));
    }
  };
  var deselectFeature = function deselectFeature(id, map) {
    selectedFeatureId = null;
    if (!map) {
      console.log('no map');
      return;
    }
    console.log('map.getLayer(activeFeatureStyles.id)', map && map.getLayer(activeFeatureStyles.id));
    activeFeatureStyles && activeFeatureStyles.id && map && map.getLayer(activeFeatureStyles.id) && map.removeLayer(activeFeatureStyles.id);
    featureIconLayerActive && displayDatasetLayerIcons && map && map.getLayer(featureIconLayerActive.id) && map.removeLayer(featureIconLayerActive.id);
    map.getSource('selectedFeature') && map.removeSource('selectedFeature');
    if (filteredLayers[datasetId + "_feature_circle_default"]) {
      map.setFilter(datasetId + "_feature_circle_default", filteredLayers[datasetId + "_feature_circle_default"].filter);
    }
    displayDatasetLayerIcons && featureIconLayer && map.setFilter('feature_icon', featureIconLayer.filter);
    selectedPopup && selectedPopup.isOpen() && selectedPopup.remove();
    if (!id) {
      deselectItem();
    }
    if (isMobile) {
      var node = document.getElementById('mobilePopupContainer');
      node && ReactDOM.unmountComponentAtNode(node);
    }
  };
  var hoverOffFeature = function hoverOffFeature() {
    if (hoveredFeatureId !== null) {
      filteredLayers[datasetId + "_feature_circle_hover"] && map.setFilter(datasetId + "_feature_circle_hover", filteredLayers[datasetId + "_feature_circle_hover"].filter);
      featureIconLayerHover && displayDatasetLayerIcons && map.setFilter('feature_icon_hover', featureIconLayerHover.filter);
      if (selectedFeatureId === null) {
        filteredLayers[datasetId + "_feature_circle_default"] && map.setFilter(datasetId + "_feature_circle_default", filteredLayers[datasetId + "_feature_circle_default"].filter);
        featureIconLayer && displayDatasetLayerIcons && map.setFilter('feature_icon', featureIconLayer.filter);
      } else {
        filteredLayers[datasetId + "_feature_circle_default"] && map.setFilter(datasetId + "_feature_circle_default", ['all', filteredLayers[datasetId + "_feature_circle_default"].filter, ['!=', 'guid', selectedFeatureId]]);
        featureIconLayer && displayDatasetLayerIcons && map.setFilter('feature_icon', ['all', featureIconLayer.filter, ['!=', 'guid', selectedFeatureId]]);
      }
      // map.setFeatureState(
      //   { source: datasetId, sourceLayer: 'default', id: hoveredFeatureId },
      //   { hover: false },
      // );

      map.setLayoutProperty(datasetId + "_feature_circle_hover", 'visibility', 'none');
      displayDatasetLayerIcons && map.setLayoutProperty('feature_icon_hover', 'visibility', 'none');
      hoverPopup && hoverPopup.isOpen() && setTimeout(function () {
        !hoveredFeatureId && hoverPopup.remove();
      }, 1000);
    }
    hoveredFeatureId = null;
  };
  map.on('click', datasetId + "_cluster_circle", function (e) {
    var _features$, _features$$properties, _features$2, _features$2$propertie;
    var features = map.queryRenderedFeatures(e.point, {
      layers: [datasetId + "_cluster_circle"]
    });
    var expansionZoom = (_features$ = features[0]) === null || _features$ === void 0 ? void 0 : (_features$$properties = _features$.properties) === null || _features$$properties === void 0 ? void 0 : _features$$properties.expansionZoom;
    if (((_features$2 = features[0]) === null || _features$2 === void 0 ? void 0 : (_features$2$propertie = _features$2.properties) === null || _features$2$propertie === void 0 ? void 0 : _features$2$propertie.expansionZoom) === 22) {
      expansionZoom = 18;
    }
    expansionZoom && map.flyTo({
      center: features[0].geometry.coordinates,
      zoom: expansionZoom
    });
  });
  if (!isMobile) {
    map.on('mousemove', datasetId + "_feature_circle_default", function (e) {
      if (e.features.length > 0) {
        var features = map.queryRenderedFeatures(e.point, {
          layers: [datasetId + "_feature_circle_default"]
        });
        if (features[0].id !== hoveredFeatureId) {
          hoverItem(features[0].id);
        }
      }
    });
    map.on('click', datasetId + "_feature_circle_hover", function (e) {
      var features = map.queryRenderedFeatures(e.point, {
        layers: [datasetId + "_feature_circle_hover"]
      });
      selectItem(features[0].id);
    });
    map.on('mouseleave', datasetId + "_feature_circle_hover", function () {
      hoverOffItem();
    });
    map.on('mousemove', Object.keys(filteredLayers), function () {
      map.getCanvasContainer().style.cursor = 'pointer';
    });
    map.on('mouseleave', Object.keys(filteredLayers), function () {
      map.getCanvasContainer().style.cursor = '';
    });
  } else {
    map.on('click', datasetId + "_feature_circle_default", function (e) {
      var features = map.queryRenderedFeatures(e.point, {
        layers: [datasetId + "_feature_circle_default"]
      });
      selectItem(features[0].id);
    });
  }
  map.on('click', function (e) {
    var features = map.queryRenderedFeatures(e.point);
    var _findVisitPoi = findVisitPoi(e.point, window.THREE_BOX),
      interactedObject = _findVisitPoi.interactedObject,
      intersectionExists = _findVisitPoi.intersectionExists;
    var foundModelId;
    if (intersectionExists) {
      foundModelId = interactedObject.parent.modelId;
      var modelConfig = window.THREE_MODELS.find(function (m) {
        return m.modelId === foundModelId;
      });
      if (!(modelConfig && (modelConfig.interactive === true || typeof modelConfig.interactive === 'object' && modelConfig.interactive.select) && interactedObject)) {
        selectedFeatureId && deselectFeature(null, map);
      }
    } else {
      var _features$3, _features$3$layer;
      if (!Object.keys(filteredLayers).includes(features === null || features === void 0 ? void 0 : (_features$3 = features[0]) === null || _features$3 === void 0 ? void 0 : (_features$3$layer = _features$3.layer) === null || _features$3$layer === void 0 ? void 0 : _features$3$layer.id)) {
        selectedFeatureId && deselectFeature(null, map);
      }
    }
  });
};
export var addLayer = function addLayer(map, layersGroup) {
  var _layersGroup, _layersGroup2, _layers;
  layersGroup = JSON.parse(JSON.stringify(layersGroup));
  var sources = (_layersGroup = layersGroup) === null || _layersGroup === void 0 ? void 0 : _layersGroup.sources;
  Object.keys(sources).map(function (sourceId) {
    return map.addSource(sourceId, sources[sourceId]);
  });
  var layers = (_layersGroup2 = layersGroup) === null || _layersGroup2 === void 0 ? void 0 : _layersGroup2.layers;
  layers = layers.map(function (layer) {
    if (layer.id.includes(':active') || layersGroup.disabled) {
      layer.layout !== null ? layer.layout.visibility = 'none' : layer.layout = {
        visibility: 'none'
      };
    }
    return filterLayer(layer);
  });
  (_layers = layers) === null || _layers === void 0 ? void 0 : _layers.map(function (layer) {
    return map.addLayer(layer);
  });
};
export function switchBasemap(_x, _x2, _x3, _x4, _x5) {
  return _switchBasemap.apply(this, arguments);
}
function _switchBasemap() {
  _switchBasemap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(map, styleID, accessToken, secLayers, datasetLayersNames) {
    var _yield$axios$get, newStyle, currentStyle, appLayers;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axios.get("https://api.mapbox.com/styles/v1/" + styleID + "?access_token=" + accessToken);
        case 2:
          _yield$axios$get = _context.sent;
          newStyle = _yield$axios$get.data;
          currentStyle = map.getStyle();
          newStyle.sources = Object.assign({}, currentStyle.sources, newStyle.sources);
          appLayers = currentStyle.layers.filter(function (el) {
            // console.log(el)
            return secLayers.includes(el.id) || datasetLayersNames.includes(el.id);
          });
          newStyle.layers = [].concat(newStyle.layers, appLayers);
          map.setStyle(newStyle);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _switchBasemap.apply(this, arguments);
}
function filterLayer(layer, datasetId) {
  if (datasetId === void 0) {
    datasetId = null;
  }
  layer = JSON.parse(JSON.stringify(layer));
  if ('advancedSettings' in layer && datasetId) {
    if (!layer.advancedSettings) {
      switch (layer.id) {
        case 'cluster_circle':
          {
            layer.filter = ['==', 'cluster', true];
            layer.type = 'circle';
            break;
          }
        case 'cluster_label':
          {
            layer.filter = ['==', 'cluster', true];
            layer.type = 'symbol';
            layer.layout = {
              'text-anchor': 'center',
              'text-allow-overlap': true,
              'text-field': '{point_count}'
            };
            break;
          }
        case 'feature_circle_default':
          {
            layer.filter = ['!has', 'cluster'];
            layer.type = 'circle';
            break;
          }
        case 'feature_circle_hover':
          {
            layer.filter = ['!has', 'cluster'];
            layer.type = 'circle';
            layer.layout = {
              visibility: 'none'
            };
            break;
          }
        case 'feature_circle_active':
          {
            layer.filter = ['!has', 'cluster'];
            layer.type = 'circle';
            break;
          }
      }
      layer.source = datasetId;
      layer.sourceLayer = 'default';
    }
  }
  if (datasetId) {
    if (!layer.customId) {
      layer.id = datasetId + "_" + layer.id;
    } else {
      layer.id = layer.customId;
      delete layer['customId'];
    }
  }
  layer.filter = !layer.filter ? null : typeof layer.filter === 'string' ? JSON.parse(layer.filter) : layer.filter;
  !layer.filter ? delete layer['filter'] : '';
  !layer.layout ? delete layer['layout'] : '';
  !layer.paint ? delete layer['paint'] : '';
  !layer.maxzoom ? delete layer['maxzoom'] : '';
  !layer.minzoom ? delete layer['minzoom'] : '';
  layer.sourceLayer ? Object.defineProperty(layer, 'source-layer', Object.getOwnPropertyDescriptor(layer, 'sourceLayer')) : '';
  delete layer['sourceLayer'];
  return layer;
}
export var remove3DBuildingsLayer = function remove3DBuildingsLayer(map) {
  map.getLayer(extrudedBuildingsLayerID) && map.removeLayer(extrudedBuildingsLayerID);
};
export var add3dBuildingsLayer = function add3dBuildingsLayer(map, currentBasemap) {
  var _sources, _sources2;
  var layers = currentBasemap.customLayer ? currentBasemap.customLayer[0].layers.map(function (_) {
    return _extends({}, _, {
      id: extrudedBuildingsLayerID,
      source: extrudedBuildingsLayerID,
      'source-layer': _.sourceLayer
    });
  }) : [];
  !map.getLayer(extrudedBuildingsLayerID) && !map.getSource(extrudedBuildingsLayerID) && (currentBasemap.isCustomLayer && currentBasemap.customLayer ? addLayer(map, {
    sources: (_sources = {}, _sources[extrudedBuildingsLayerID] = currentBasemap.customLayer[0].sources, _sources),
    layers: layers
  }) : addLayer(map, {
    sources: (_sources2 = {}, _sources2[extrudedBuildingsLayerID] = {
      type: 'vector',
      url: 'mapbox://mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2'
    }, _sources2),
    layers: [{
      id: extrudedBuildingsLayerID,
      type: 'fill-extrusion',
      source: extrudedBuildingsLayerID,
      'source-layer': 'building',
      filter: ['==', 'extrude', 'true'],
      paint: {
        'fill-extrusion-color': '#E8EBED',
        'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
        'fill-extrusion-base': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'min_height']],
        'fill-extrusion-opacity': 0.6
      }
    }]
  }));
};